/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Injectable } from '@angular/core';
import Swal, { SweetAlertResult } from 'sweetalert2';
import * as toastr from 'toastr';

export enum DefaultMessageText {
	ACEPTAR = 'Aceptar',
	CONTINUAR = 'Si, Continuar',
	CANCELAR = 'No, Cancelar',
	CARCANGDO = 'Cargando...!',
	VALIDANDO = 'Validando...!',
	BEFORE_CLOSE_PAGE_TITLE = '¿Estas seguro que quieres salir del sitio web?',
	BEFORE_CLOSE_PAGE_MESSAGE = 'Es posible que los datos ingresados no se guarden.',
	ERROR = '¡ERROR!',
	SUCCESS = '¡Bien hecho!',
	INFO = '¡Atento!',
	WARNING = '¡ADVERTENCIA!',
}

@Injectable({
	providedIn: 'root',
})
export class MessageUtilService {
	message = '';
	getMessageError(message: string, title: string = 'Error') {
		(toastr.options.positionClass = 'toast-bottom-right'),
			(toastr.options.closeButton = true),
			(toastr.options.progressBar = true),
			(toastr.options.newestOnTop = true),
			toastr['error'](message, `<h5 class='text-white'> ${title} </h5>`);
		return toastr;
	}

	getAlertWarning(mensaje: string, title = 'Advertencia') {
		(toastr.options.positionClass = 'toast-bottom-right'),
			(toastr.options.closeButton = true),
			(toastr.options.progressBar = true),
			(toastr.options.newestOnTop = true);
		toastr['warning'](mensaje, `<h5 class='text-white'> ${title} </h5>`);
		return toastr;
	}

	getAlertSuccess(mensaje: string) {
		(toastr.options.positionClass = 'toast-bottom-right'),
			(toastr.options.closeButton = true),
			(toastr.options.progressBar = true),
			(toastr.options.newestOnTop = true),
			toastr['success'](mensaje);
		return toastr;
	}

	getMessageWarning(title: string = '', mensaje: string = '', focusCancel: boolean = true) {
		return Swal.fire({
			title: title,
			html: mensaje,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#0ABB87',
			cancelButtonColor: '#FD397A',
			confirmButtonText: 'Si',
			cancelButtonText: 'No',
			focusCancel: focusCancel,
			allowOutsideClick: false,
		});
	}
	getMessageQuestion(mensaje: string): Promise<SweetAlertResult<unknown>>;
	getMessageQuestion(mensaje: string, focusCancel: boolean): Promise<SweetAlertResult<unknown>>;
	getMessageQuestion(title: string, mensaje: string): Promise<SweetAlertResult<unknown>>;
	getMessageQuestion(
		title: string,
		mensaje: string,
		focusCancel: boolean
	): Promise<SweetAlertResult<unknown>>;
	getMessageQuestion(
		arg1: string,
		arg2?: string | boolean,
		arg3?: boolean
	): Promise<SweetAlertResult<unknown>> {
		let title = '';
		let mensaje = '';
		let focusCancel = true;
		if (typeof arg2 === 'string') {
			title = arg1;
			mensaje = arg2;
			if (typeof arg3 === 'boolean') {
				focusCancel = arg3;
			}
		} else {
			mensaje = arg1;
			if (typeof arg2 === 'boolean') {
				focusCancel = arg2;
			}
		}
		return Swal.fire({
			title: title,
			html: mensaje,
			icon: 'question',
			showCancelButton: true,
			focusCancel: focusCancel,
			confirmButtonColor: '#0ABB87',
			cancelButtonColor: '#FD397A',
			confirmButtonText: 'Si',
			cancelButtonText: 'No',
			allowOutsideClick: false,
		});
	}
	getMessageQuestionFocusAcept(
		arg1: string,
		arg2?: string | boolean,
		arg3?: boolean
	): Promise<SweetAlertResult<unknown>> {
		let title = '';
		let mensaje = '';
		let focusConfirm = true;
		if (typeof arg2 === 'string') {
			title = arg1;
			mensaje = arg2;
			if (typeof arg3 === 'boolean') {
				focusConfirm = arg3;
			}
		} else {
			mensaje = arg1;
			if (typeof arg2 === 'boolean') {
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				focusConfirm = arg2;
			}
		}
		return Swal.fire({
			title: title,
			html: mensaje,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0ABB87',
			cancelButtonColor: '#FD397A',
			confirmButtonText: 'Si',
			cancelButtonText: 'No',
			focusConfirm: true,
			allowOutsideClick: false,
		});
	}

	getMessageLoading(title: string, mensaje: string = '') {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		Swal.fire({
			title: `${title}`,
			text: mensaje,
			allowOutsideClick: false,
		});
		return Swal.showLoading();
	}

	closeLoading() {
		return Swal.close();
	}

	getMessageSuccess(titulo: string, mensaje: string) {
		return Swal.fire({
			icon: 'success',
			title: titulo,
			text: mensaje,
		});
	}

	getFailMessage(mensaje: string) {
		return Swal.fire({
			icon: 'error',
			title: 'Error',
			text: mensaje,
		});
	}

	getMessageSuccessDelete(mensaje: string) {
		return Swal.fire({
			icon: 'success',
			title: 'Eliminación exitosa',
			text: mensaje,
		});
	}

	getMessageInfo(mensaje: string, title = 'Información') {
		return Swal.fire({
			icon: 'info',
			title,
			html: mensaje,
		});
	}

	getMessageSuccessTransmit(mensaje: string) {
		return Swal.fire({
			icon: 'success',
			title: 'Transmisión exitosa',
			text: mensaje,
		});
	}

	getNotResultSpanish() {
		return 'No existen resultados';
	}

	loadTable() {
		return `<span class="ag-overlay-loading-top d-flex align-items-center
		border-0 bg-white shadow p-4 text-info" style="height: 20px;">
		<img src="assets/media-demo/loading.gif"
		height="20" width="25" class="me-2"><strong>Cargando registros</strong></span>`;
	}
	loadTableIsBlank() {
		return `<span class="ag-overlay-loading-center border-0 bg-transparent">
		No existen Documentos Relacionados ...</span>`;
	}
	loadClassDisplayFlex(justifyContent: string, alignItems: string) {
		return `d-flex justify-content-${justifyContent} align-items-${alignItems}`;
	}
}
